import React from 'react';
export function Footer() {
  return <footer className="bg-petrol py-8 border-t border-night-border text-center px-4" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <p className="text-gold-dark text-sm" data-id="element-129">
          © {new Date().getFullYear()} Mega Pack Química en el Aula — Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}